module.exports = __webpack_public_path__ + "e498f0b0ab96d3e68f5892cb76897fd0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/fireplace.png
// module id = 975
// module chunks = 0